<template>
  <div class="pcTabs">
    <div v-for="(item, index) in tabsName" :key="item" :class="index == activeIndex ? 'activeTab' : 'normalTab'" :style="`width:${94/tabsName.length}%`" @click="active(index)">{{item}}</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      tabsName: [],
      activeIndex: 0
    };
  },

  props: ['tabs'],

  methods: {
    active(index) {
      this.activeIndex = index
      this.$parent.activeTab(index)
    }
  },

  created() {
    this.tabsName = this.tabs && this.tabs.length ? this.tabs : ['待使用', '已使用', '已取消', '已过期']
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.pcTabs{
  .activeTab, .normalTab{
    display: inline-block;
    height: 0.3rem;
    line-height: 0.3rem;
    padding-bottom: 0.1rem;
    font-weight: 500;
    font-size: 32px;
    cursor: pointer;
  }
  .activeTab{

  }
}
</style>
